var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    viewBox: "0 0 9 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.71599 8L8.6705 2.32904C9.10983 1.91062 9.10983 1.23223 8.6705 0.813814C8.23116 0.395395 7.51884 0.395395 7.0795 0.813814L0.329505 7.24239C-0.109835 7.6608 -0.109835 8.3392 0.329505 8.75762L7.0795 15.1862C7.51884 15.6046 8.23116 15.6046 8.6705 15.1862C9.10983 14.7678 9.10983 14.0894 8.6705 13.671L2.71599 8Z",
    fill: "#303141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.289e92d296e0c1ff10b6defcc8f81c81.svg";
export { ForwardRef as ReactComponent };